import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../core/auth/auth.service';
import { LoginSessionState, SessionTimerServiceService } from '../../../core/auth/session-timer-service.service';
import { AuthorizationGuardService } from '../../../core/authorization-guard.service';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';

// eslint-disable-next-line no-shadow
enum DialogCloseAction {
  None,
  RefreshToken,
  ReturnToLogin,
}

@Component({
  selector: 'hb-session-timeout',
  template: '',
  providers: [AuthorizationGuardService],
})
export class SessionTimeoutComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<boolean> = new Subject();
  private dialogCloseAction: DialogCloseAction = DialogCloseAction.None;
  private doActionOnCancel: boolean = false;
  constructor(
    public bsModalRef: BsModalRef,
    private timeoutService: SessionTimerServiceService,
    private modalService: BsModalService,
    private authService: AuthService,
    private sessionTimerServiceService: SessionTimerServiceService,
  ) { }

  public ngOnInit(): void {
    this.timeoutService.loginSessionStateChanged.pipe(takeUntil(this.unsubscribe)).subscribe(state => {
      switch (state) {
        // User may have refreshed token in another browser tab so close the window if it's open here
        case LoginSessionState.LoggedIn: {
          if (this.bsModalRef) {
            this.dialogCloseAction = DialogCloseAction.None;
            this.bsModalRef.hide();
          }
          break;
        }
        case LoginSessionState.NotLoggedIn: {
          this.authService.logout();
          break;
        }
        // Session about to expire.  Pop up a dioalog
        case LoginSessionState.Expiring: {
          this.dialogCloseAction = DialogCloseAction.RefreshToken;
          this.doActionOnCancel = false;
          this.showDialog('Session Timeout', 'Your session is about to expire', 'Click OK to continue working');
          break;
        }
      }
    });
  }

  showDialog(title: string, messageTop: string, messageBottom: string) {
    this.bsModalRef = this.modalService.show(ConfirmationDialogComponent);
    if (!this.bsModalRef) {
      return;
    }

    this.bsModalRef.content.title = title;
    this.bsModalRef.content.messageTop = messageTop;
    this.bsModalRef.content.messageBottom = messageBottom;
    this.bsModalRef.content.showCancel = true;

    const content = this.bsModalRef.content;
    (content as ConfirmationDialogComponent).afterClosed.pipe(takeUntil(this.unsubscribe)).subscribe(confirm => {
      if (confirm) {
        this.DoCloseAction();
        this.doActionOnCancel = true;
      }
      else if (!confirm && !this.doActionOnCancel) {
        this.dialogCloseAction = DialogCloseAction.ReturnToLogin;
        this.DoCloseAction();
      }
      this.bsModalRef = null;
    });
  }

  private DoCloseAction() {
    switch (this.dialogCloseAction) {
      case DialogCloseAction.RefreshToken: {
        this.sessionTimerServiceService.start();
        this.authService.setpermissions();
        break;
      }
      case DialogCloseAction.ReturnToLogin: {
        this.authService.logout();
        break;
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }
}
